import { render } from "./NoPermissionPage.vue?vue&type=template&id=23f75b06&ts=true"
import script from "./NoPermissionPage.vue?vue&type=script&lang=ts"
export * from "./NoPermissionPage.vue?vue&type=script&lang=ts"

import "./NoPermissionPage.vue?vue&type=style&index=0&id=23f75b06&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__